<!-- 页脚 -->
<template>
  <footer ref="footerRef">
    <div class="mainBox footerBox">
      <div class="left">
        <div class="leftTitle">耀客明道物联网（武汉）有限公司</div>
        <OssImg alt="" src="images/homeIcon14.png" class="icon" />

        <div class="footerText" style="margin-top: 16px">
          <OssImg class="footerImg" src="images/homeIcon9.png" alt="" />
          武汉市东湖新技术开发区珞喻东路4号慧谷时空1栋26层01号
        </div>
        <div class="footerText">
          <OssImg class="footerImg" src="images/homeIcon10.png" alt="" />
          400-966-5960 | 027- 87003747
        </div>
        <div class="footerText">
          <OssImg class="footerImg" src="/UIV3/email.png" alt="" />
          邮箱：sales@yaokegroup.com
        </div>
      </div>
      <div class="right">
        <div class="qrcodeBox">
          <div class="qrcodeItem" v-for="(item, index) in qrCodeList" :key="index">
            <img class="qrcodeImg" :src="item.src" alt="" @click="showQrCode(item.src)" />
            <div>{{ item.name }}</div>
          </div>
        </div>
        <!-- 弹框放大查看 -->
        <div class="qrModal" v-if="showModal" @click="showModal = false">
          <img class="qrModalImg" :src="currentQrCode" alt="" />
        </div>
        <div class="menuItem">
          <div class="menuTitle">快捷入口</div>
          <div class="footerTextMin">
            <div class="subMenu" @click="navTo('/solution/index')">
              解决方案
            </div>
            <div class="subMenu" @click="navTo('/product/index')">

              产品中心
            </div>
            <div class="subMenu" @click="navTo('/customerCase')">案例</div>
            <div class="subMenu" @click="navTo('/news/index')">新闻</div>
            <div class="subMenu" @click="navTo('/cooperativeEcosystem')">
              合作生态
            </div>
            <div class="subMenu" @click="navTo('/aboutUs')">关于我们</div>
          </div>
        </div>
        <div class="menuItem">
          <div class="menuTitle">友情链接</div>
          <div class="footerTextMin">
            <div class="subMenu" v-for="(item, index) in linkList" :key="index" @click="openWindow(item.linkAddress)">
              {{ item.linkName }}
            </div>
          </div>
        </div>
        <div class="menuItem">
          <div class="menuTitle">留言接听</div>
          <div class="footerTextMin" style="margin-bottom: 8px">
            <div class="subMenu" @click="navTo('/consult')">留言接听</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import HomeApi from "@/api/homeApi";
import { onMounted, ref } from "vue";
import { navTo } from "@/utils/util";
import qrCodeImg from "@/assets/images/qrCode.jpg";
import qrCodeImg2 from "@/assets/images/qrCode2.jpg";
import qrCodeImg3 from "@/assets/images/qrCode3.png";

const linkList = ref([]);
const showModal = ref(false);
const currentQrCode = ref("");

const qrCodeList = ref([
  { name: "订阅号", src: qrCodeImg },
  { name: "服务号", src: qrCodeImg2 },
  { name: "视频号", src: qrCodeImg3 }
]);

onMounted(() => {
  getLinkList();
});

const getLinkList = async () => {
  let res = await HomeApi.getFriendLink();
  linkList.value = res || [];
};

const openWindow = (link) => {
  window.open(link);
};

const showQrCode = (src) => {
  currentQrCode.value = src;
  showModal.value = true;
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  padding: 1rem 0 1rem 0; // 40px/16
  background-color: #424242;

  .footerBox {
    height: 100%;
    margin: auto;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .left,
  .right {
    height: 100%;
  }

  .right {
    display: flex;
  }

  .leftTitle {
    color: #ffffff;
    font-family: "PingFang SC";
    font-weight: 600;
    font-size: 1.5rem; // 24px/16
    line-height: 2.125rem; // 34px/16
    margin-bottom: 0.125rem; // 2px/16
  }

  .icon {
    width: 6.5rem; // 104px/16
    height: 1.6875rem; // 27px/16
  }

  .qrcodeBox {
    display: flex;

    .qrcodeItem {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-weight: 500;
      font-size: 1rem; // 16px/16
      line-height: 1.375rem; // 22px/16
      margin-right: 1.5rem; // 24px/16
      color: #fff;

      .qrcodeImg {
        width: 3.5rem; // 56px/16
        height: 3.5rem; // 56px/16
        margin-bottom: 0.5rem; // 8px/16
      }
    }
  }

  .menuItem {
    display: flex;
    flex-direction: column;
    margin-right: 1.5rem; // 24px/16
  }

  .footerText {
    text-align: justify;
    color: #a5a5a5;
    font-weight: 500;
    font-size: 1rem; // 16px/16
    line-height: 1.375rem; // 22px/16
    white-space: nowrap;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;

    .footerImg {
      width: 0.6875rem; // 11px/16
      height: 0.875rem; // 14px/16
      margin-right: 0.5rem; // 8px/16
    }
  }

  .footerTextMin {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    color: #a5a5a5;
    font-size: 13x;
    margin-bottom: 0 !important;
    height: 130px;
  }

  .footerTextMin .subMenu {
    padding: 0; // 10px/16
    white-space: nowrap;
    margin-right: 20px;
  }

  .subMenu {
    padding: 0.4375rem 0.625rem; // 7px/16 10px/16
    line-height: 2rem; // 34px/16
    cursor: pointer;
  }

  .subMenu:hover {
    color: #fff;
  }

  .qrModal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: pointer;
  }

  .qrModalImg {
    width: 200px;
    height: 200px;
    object-fit: contain;
    cursor: default;
  }

  .menuTitle {
    font-weight: bold;
    font-size: 1rem;
    color: #ffffff;
    margin-bottom: 0.5rem; // 23px/16
    // text-align: center;
  }

  .point {
    // margin: 0 0.625rem; // 10px/16
  }

  .bottom {
    border-top: 0.0625rem solid #4d82b1; // 1px/16
    margin: 1.25rem auto 0; // 20px/16
    padding-top: 1.25rem; // 20px/16
    text-align: center;
    color: #ffffff;
    font-size: 0.875rem; // 14px/16
  }
}

// @media(max-width:768px) {
//   .footerBox {
//     flex-direction: column;
//     gap: 2rem;

//     .right {
//       flex-direction: column;
//     }

//     .menuItem {
//       width: 100% !important;
//       align-items: flex-start;
//       margin-top: 1rem;
//     }

//     .menuTitle {
//       margin-bottom: 0 !important;
//     }

//     .footerTextMin {
//       flex-direction: row !important;
//       margin-left: -0.625rem !important;
//     }
//   }
// }</style>
